// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_SmartSearchType.proto

export enum ENUM_SmartSearchType {
  SMART_SEARCH_TYPE_UNSPECIFIED = 'SMART_SEARCH_TYPE_UNSPECIFIED',
  SMART_SEARCH_TYPE_FOR_MORTGAGE_PRODUCT = 'SMART_SEARCH_TYPE_FOR_MORTGAGE_PRODUCT',
  SMART_SEARCH_TYPE_FOR_BUY_PROPERTY_MAXIMUM_VALUE = 'SMART_SEARCH_TYPE_FOR_BUY_PROPERTY_MAXIMUM_VALUE',
  SMART_SEARCH_TYPE_FOR_REMORTGAGE_BORROW_MORE = 'SMART_SEARCH_TYPE_FOR_REMORTGAGE_BORROW_MORE',
  SMART_SEARCH_TYPE_FOR_REMORTGAGE_PAY_FASTER = 'SMART_SEARCH_TYPE_FOR_REMORTGAGE_PAY_FASTER',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
